import React from "react";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {startCase, get as _get} from "lodash";
import {logout, isUserLoggedIn} from "../../../utils/session/logout";
import {userHasAdminAccess} from "../../utils/auth";
import Logo from "../logo/logo";
import LogoFooter from "../logoFooter/logo";
import SidebarDisclosures from "./SidebarDisclosures";

class AdminSideBar extends React.Component {
    static defaultProps = {
        options: [],
    };

    getActiveClassOrNot = (path) => {
        return this.props.location.pathname.includes(path) ? "is-active" : "";
    };



    render() {
        return (
            <div className="sidebar-content no-print">
                <div className="menu-top">
                    <Logo mode="light"/>
                    <aside className="menu ml-3 py-3 pl-4 pr-2">

                        <ul className="menu-list">

                            {!!isUserLoggedIn() && (
                                <li className={this.getActiveClassOrNot('my-projects')}>
                                    <Link to="/my-projects/">My Projects</Link>
                                </li>
                            )}
                            <li>
                                {this.props.onNewProjectClick ? (
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.props.onNewProjectClick();
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        New Project
                                    </a>
                                ) : (
                                    <Link to="/">New Project</Link>
                                )}
                            </li>
                            {userHasAdminAccess(this.props.tokenData) &&
                            <li>
                                <Link to="/admin">Admin</Link>
                            </li>
                            }
                            <li>
                                <a href="https://blog.cleanfi.com">Knowledge Base</a>
                            </li>
                           {isUserLoggedIn() && 
                            <li>
                                <Link to="/account/edit">Profile</Link>
                            </li>
                        }



                        </ul>
                    </aside>
                </div>
                <div className="menu-footer">
                    {isUserLoggedIn() ? <>
                        <p className="has-text-centered has-text-white-bis mb-4">Hi {_get(this.props, 'tokenData.user_data.first_name', 'there')}.</p>

                        <Link to="/" onClick={logout}>
                            <span
                                className="footer-action has-text-weight-semibold has-text-white-bis  p-2 mt-3"
                                onClick={() => logout()}
                                style={{border: "1px solid white", borderRadius: "2px"}}>
                                <span className="icon"><i className="fas fa-sign-out-alt"/></span>
                                Log Out
                          </span>
                        </Link>
                    </> : <Link to="/login">
                            <span
                                className="footer-action has-text-white-bis has-text-weight-semibold p-2 mt-3"
                                style={{border: "1px solid white", borderRadius: "2px"}}>

                                <span className="icon"><i className="fas fa-sign-in-alt"/></span>
                                Log In
                            </span>
                        </Link>

                    }
                    <LogoFooter mode="light"/>
                    <SidebarDisclosures />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tokenData: state.user.decodedTokenData,
});

export default connect(mapStateToProps)(withRouter(AdminSideBar));
